import type { ContextState } from "./types";

export const defaultState = {} as ContextState;
